webpackJsonp([9],{

/***/ 1117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_truckdetail_js__ = __webpack_require__(1362);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c3d0c8b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Truckdetail_vue__ = __webpack_require__(1601);
function injectStyle (ssrContext) {
  __webpack_require__(1595)
}
var normalizeComponent = __webpack_require__(509)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c3d0c8b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_truckdetail_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c3d0c8b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Truckdetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(511);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  listSupplier: function listSupplier(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'truck', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getSupplier: function getSupplier(URL, Id, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'truck/' + Id, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getTruckDetail: function getTruckDetail(URL, Id, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'truck/detail/' + Id, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  listPattern: function listPattern(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'truck/pattern/all', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  listTrucktype: function listTrucktype(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'truck/trucktype/all', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  addTruck: function addTruck(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'truck', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  editTruck: function editTruck(URL, obj, Id, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.put(URL + 'truck/' + Id, obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  deleteTruck: function deleteTruck(URL, Id, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.delete(URL + 'truck/' + Id, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getExportCalendar: function getExportCalendar(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'truck/getexportcalendar', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1362:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_truck__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modal_truck_edit_modal__ = __webpack_require__(1597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modal_truck_add_modal__ = __webpack_require__(1599);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'truck',
  components: {
    truckListEditModal: __WEBPACK_IMPORTED_MODULE_2__components_modal_truck_edit_modal__["a" /* default */],
    trucklistAddModal: __WEBPACK_IMPORTED_MODULE_3__components_modal_truck_add_modal__["a" /* default */]
  },
  data: function data() {
    return {
      search_text: '',
      is_active: 1,
      isLoad: false,
      str_data: '',
      modal_type: 0,
      spl_id: '',
      spl_code: '',
      spl_name: '',
      spl_plant_code: '',
      result_data: {},
      modal_data: {
        cdp_id: '',
        spl_id: '',
        cdpl_truck_no: '',
        cdpl_truck_type: '',
        cdpl_shipping_time: '',
        cdpl_shipping_time_h: '',
        cdpl_shipping_time_m: '',
        cdpl_lead_time_day: '',
        cdpl_delivery_time: '',
        cdpl_delivery_time_h: '',
        cdpl_delivery_time_m: '',
        cdpl_delivery_time_end_h: '',
        cdpl_delivery_time_end_m: '',
        cdmp_mon: false,
        cdmp_tue: false,
        cdmp_wed: false,
        cdmp_thu: false,
        cdmp_fri: false,
        cdmp_sat: false
      }
    };
  },

  methods: {
    backTopage: function backTopage() {
      this.$router.push({
        name: 'Truck'
      });
    },
    itemRender: function itemRender(current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous';
      } else if (type === 'next') {
        return 'Next';
      }
      return originalElement;
    },
    activePage: function activePage(value) {
      this.active_page = value;
      this.search();
    },
    search: function search() {
      var _this = this;

      this.isLoad = true;
      __WEBPACK_IMPORTED_MODULE_1__models_truck__["a" /* default */].getTruckDetail(this.$store.state.URLHost, this.spl_id, this.header, function (result) {
        if (result.response === true) {
          _this.result_data = result.data;
        } else {
          _this.alert_msg('warning', 'Pattern', result.message);
        }
        _this.isLoad = false;
      }, function (error) {
        _this.alert_msg('error', 'Pattern', error.message);
        _this.isLoad = false;
      });
    },
    getSupplier: function getSupplier() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__models_truck__["a" /* default */].getSupplier(this.$store.state.URLHost, this.spl_id, this.header, function (result) {
        if (result.response === true) {
          _this2.spl_code = result.data.code;
          _this2.spl_name = result.data.name;
          _this2.spl_plant_code = result.data.plantcode;
        } else {
          _this2.alert_msg('warning', 'Pattern', result.message);
        }
      }, function (error) {
        _this2.alert_msg('error', 'Pattern', error.message);
      });
    },
    addTrucklist: function addTrucklist() {
      this.modal_type = 0;
      this.modal_data = {
        cdp_id: '',
        spl_id: this.spl_id,
        spl_name: this.spl_name,
        spl_plant_code: this.spl_plant_code,
        cdpl_truck_no: '',
        cdpl_truck_type: '',
        cdpl_shipping_time: '',
        cdpl_shipping_time_h: '',
        cdpl_shipping_time_m: '',
        cdpl_lead_time_day: '',
        cdpl_delivery_time: '',
        cdpl_delivery_time_h: '',
        cdpl_delivery_time_m: '',
        cdpl_delivery_time_end_h: '',
        cdpl_delivery_time_end_m: '',
        cdmp_mon: false,
        cdmp_tue: false,
        cdmp_wed: false,
        cdmp_thu: false,
        cdmp_fri: false,
        cdmp_sat: false
      };
      this.ModalBoots('TruckModal').show();
    },
    editTrucklist: function editTrucklist(obj) {
      this.modal_type = 1;
      this.modal_data = obj;
      this.ModalBoots('TruckModal').show();
    },
    deleteTrucklist: function deleteTrucklist(obj) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.fire({
        title: 'Are you sure?',
        text: 'Confirm delete : Pattern ' + obj.cdp_name + ' Truck No.' + obj.cdpl_truck_no,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#67757c',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'Cancel'
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_1__models_truck__["a" /* default */].deleteTruck(_this3.$store.state.URLHost, obj.cdpl_id, _this3.header, function (result) {
            if (result.response === true) {
              _this3.alert_msg('success', 'Successful.', result.message);
            } else {
              _this3.alert_msg('error', 'An error occurred.', result.message);
            }
            _this3.search();
          }, function (error) {
            _this3.alert_msg('error', 'An error occurred.', error.message);
            _this3.search();
          });
        }
      });
    },
    goTruckPattern: function goTruckPattern(obj) {
      this.$router.push({
        name: 'truckpattern',
        params: {
          spl_id: this.spl_id
        }
      });
    }
  },
  created: function created() {
    this.checkOAuth();
    this.spl_id = typeof this.$route.params.spl_id !== 'undefined' ? this.$route.params.spl_id : 0;
  },
  mounted: function mounted() {
    var _this4 = this;

    //  this.spl_id = this.$route.query.id !== undefined ? this.$route.query.id : this.spl_id
    setTimeout(function () {
      if (sessionStorage.token) {
        _this4.getSupplier();
        setTimeout(function () {
          _this4.activePage(1);
        }, 300);
      } else {
        setTimeout(function () {
          _this4.getSupplier();
          setTimeout(function () {
            _this4.activePage(1);
          }, 300);
        }, 1000);
      }
    }, 1000);
  }
});

/***/ }),

/***/ 1363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_truck__ = __webpack_require__(1158);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import moment from 'moment'

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['modalEditTruck', 'loadNewTruck'],
  data: function data() {
    return {
      cdp_id: '',
      cdp_name: '',
      spl_id: '',
      // cdmp_sequence: '',
      cdpl_truck_no: '',
      cdpl_truck_type: '',
      cdpl_shipping_time: '',
      cdpl_shipping_time_h: '',
      cdpl_shipping_time_m: '',
      cdpl_lead_time_day: '',
      cdpl_delivery_time: '',
      cdpl_delivery_time_h: '',
      cdpl_delivery_time_m: '',
      cdpl_delivery_time_end: '',
      cdpl_delivery_time_end_h: '',
      cdpl_delivery_time_end_m: '',
      cdmp_mon: 0,
      cdmp_tue: 0,
      cdmp_wed: 0,
      cdmp_thu: 0,
      cdmp_fri: 0,
      cdmp_sat: 0,
      spl_name: '',
      spl_plant_code: '',
      patternModalList: [],
      trucktypeModalList: []
    };
  },

  methods: {
    // moment,
    checkForm: function checkForm() {
      if (this.cdp_id !== '' && this.spl_id !== '' && this.cdpl_truck_no !== '' && this.cdpl_shipping_time_h !== '' && this.cdpl_shipping_time_m !== '' && this.cdpl_lead_time_day !== '' && this.cdpl_delivery_time_h !== '' && this.cdpl_delivery_time_m !== '' && this.cdpl_delivery_time_end_h !== '' && this.cdpl_delivery_time_end_m !== '') {
        this.updateTruck();
      } else {
        $('#formEditTruck').addClass('was-validated');
      }
    },
    updateTruck: function updateTruck() {
      var _this = this;

      $('.preloader').fadeIn();
      var formData = {
        cdp_id: this.cdp_id,
        spl_id: this.spl_id,
        // cdmp_sequence: this.cdmp_sequence,
        cdpl_truck_no: this.cdpl_truck_no,
        cdpl_truck_type: this.cdpl_truck_type,
        cdpl_shipping_time_h: this.cdpl_shipping_time_h,
        cdpl_shipping_time_m: this.cdpl_shipping_time_m,
        cdpl_lead_time_day: this.cdpl_lead_time_day,
        cdpl_delivery_time_h: this.cdpl_delivery_time_h,
        cdpl_delivery_time_m: this.cdpl_delivery_time_m,
        cdpl_delivery_time_end_h: this.cdpl_delivery_time_end_h,
        cdpl_delivery_time_end_m: this.cdpl_delivery_time_end_m,
        cdmp_mon: this.cdmp_mon ? 1 : 0,
        cdmp_tue: this.cdmp_tue ? 1 : 0,
        cdmp_wed: this.cdmp_wed ? 1 : 0,
        cdmp_thu: this.cdmp_thu ? 1 : 0,
        cdmp_fri: this.cdmp_fri ? 1 : 0,
        cdmp_sat: this.cdmp_sat ? 1 : 0
      };
      __WEBPACK_IMPORTED_MODULE_0__models_truck__["a" /* default */].editTruck(this.$store.state.URLHost, formData, this.cdpl_id, this.header, function (result) {
        if (result.response === true) {
          _this.loadNewTruck();
          _this.alert_msg('success', 'Successful', result.message);
          $('.preloader').fadeOut();
          $('#TruckModal').modal('hide');
        } else {
          _this.loadNewTruck();
          _this.alert_msg('warning', 'An error occurred.', result.message);
          $('.preloader').fadeOut();
          $('#TruckModal').modal('hide');
        }
      }, function (error) {
        _this.loadNewTruck();
        _this.alert_msg('error', 'An error occurred.', error.message);
        $('.preloader').fadeOut();
        $('#TruckModal').modal('hide');
      });
    },
    listPattern: function listPattern() {
      var _this2 = this;

      this.patternModalList = [];
      __WEBPACK_IMPORTED_MODULE_0__models_truck__["a" /* default */].listPattern(this.$store.state.URLHost, this.header, function (result) {
        if (result.response === true) {
          _this2.patternModalList = result.data;
        } else {
          _this2.alert_msg('warning', 'An error occurred.', result.message);
        }
      }, function (error) {
        _this2.alert_msg('error', 'An error occurred.', error.message);
      });
    },
    listTrucktype: function listTrucktype() {
      var _this3 = this;

      this.trucktypeModalList = [];
      __WEBPACK_IMPORTED_MODULE_0__models_truck__["a" /* default */].listTrucktype(this.$store.state.URLHost, this.header, function (result) {
        if (result.response === true) {
          _this3.trucktypeModalList = result.data;
        } else {
          _this3.alert_msg('warning', 'An error occurred.', result.message);
        }
      }, function (error) {
        _this3.alert_msg('error', 'An error occurred.', error.message);
      });
    }
  },
  watch: {
    modalEditTruck: {
      immediate: true,
      deep: true,
      handler: function handler(newValue, oldValue) {
        this.listPattern();
        this.listTrucktype();
        this.spl_name = newValue.spl_name;
        this.spl_id = newValue.spl_id;
        this.spl_plant_code = newValue.spl_plant_code;
        // this.cdmp_sequence = newValue.cdmp_sequence
        this.cdp_id = newValue.cdp_id;
        this.cdp_name = newValue.cdp_name;
        this.cdpl_truck_no = newValue.cdpl_truck_no;
        this.cdpl_truck_type = newValue.cdpl_truck_type;
        this.cdpl_shipping_time_h = newValue.cdpl_shipping_time_h;
        this.cdpl_shipping_time_m = newValue.cdpl_shipping_time_m;
        this.cdpl_lead_time_day = newValue.cdpl_lead_time_day;
        this.cdpl_delivery_time_h = newValue.cdpl_delivery_time_h;
        this.cdpl_delivery_time_m = newValue.cdpl_delivery_time_m;
        this.cdpl_delivery_time_end_h = newValue.cdpl_delivery_time_end_h;
        this.cdpl_delivery_time_end_m = newValue.cdpl_delivery_time_end_m;
        this.cdmp_mon = parseInt(newValue.cdmp_mon) === 1;
        this.cdmp_tue = parseInt(newValue.cdmp_tue) === 1;
        this.cdmp_wed = parseInt(newValue.cdmp_wed) === 1;
        this.cdmp_thu = parseInt(newValue.cdmp_thu) === 1;
        this.cdmp_fri = parseInt(newValue.cdmp_fri) === 1;
        this.cdmp_sat = parseInt(newValue.cdmp_sat) === 1;
        this.cdpl_id = newValue.cdpl_id;
      }
    }
  },
  mounted: function mounted() {
    var myModalEl = document.getElementById('TruckModal');
    myModalEl.addEventListener('shown.bs.modal', function (event) {
      $('#formEditTruck').removeClass('was-validated');
    });
    $(document).on('show.bs.modal', '.modal', function () {
      var zIndex = 1040 + 10 * $('.modal:visible').length;
      $(this).css('z-index', zIndex);
      setTimeout(function () {
        $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
      }, 0);
    });
  }
});

/***/ }),

/***/ 1364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_truck__ = __webpack_require__(1158);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import moment from 'moment'

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['modalAddTruck', 'loadNewTruck'],
  data: function data() {
    return {
      cdp_id: '',
      spl_id: '',
      // cdmp_sequence: '',
      cdpl_truck_no: '',
      cdpl_truck_type: '',
      cdpl_shipping_time: '',
      cdpl_shipping_time_h: '00',
      cdpl_shipping_time_m: '00',
      cdpl_lead_time_day: '',
      cdpl_delivery_time: '',
      cdpl_delivery_time_h: '00',
      cdpl_delivery_time_m: '00',
      cdpl_delivery_end_time: '',
      cdpl_delivery_time_end_h: '00',
      cdpl_delivery_time_end_m: '00',
      cdmp_mon: false,
      cdmp_tue: false,
      cdmp_wed: false,
      cdmp_thu: false,
      cdmp_fri: false,
      cdmp_sat: false,
      spl_name: '',
      spl_plant_code: '',
      patternModalList: [],
      trucktypeModalList: []
    };
  },

  methods: {
    // moment,
    checkForm: function checkForm() {
      if (this.cdp_id !== '' && this.spl_id !== '' && this.cdpl_truck_no !== '' && this.cdpl_shipping_time_h !== '' && this.cdpl_shipping_time_m !== '' && this.cdpl_lead_time_day !== '' && this.cdpl_delivery_time_h !== '' && this.cdpl_delivery_time_m !== '' && this.cdpl_delivery_time_end_h !== '' && this.cdpl_delivery_time_end_m !== '') {
        this.insertTruck();
      } else {
        $('#formAddTruck').addClass('was-validated');
      }
    },
    insertTruck: function insertTruck() {
      var _this = this;

      $('.preloader').fadeIn();
      var formData = {
        cdp_id: this.cdp_id,
        spl_id: this.spl_id,
        // cdmp_sequence: this.cdmp_sequence,
        cdpl_truck_no: this.cdpl_truck_no,
        cdpl_truck_type: this.cdpl_truck_type,
        // cdpl_shipping_time: this.dateFormatTime(this.cdpl_shipping_time),
        cdpl_shipping_time_h: this.cdpl_shipping_time_h,
        cdpl_shipping_time_m: this.cdpl_shipping_time_m,
        cdpl_lead_time_day: this.cdpl_lead_time_day,
        cdpl_delivery_time_h: this.cdpl_delivery_time_h,
        cdpl_delivery_time_m: this.cdpl_delivery_time_m,
        cdpl_delivery_time_end_h: this.cdpl_delivery_time_end_h,
        cdpl_delivery_time_end_m: this.cdpl_delivery_time_end_m,
        cdmp_mon: this.cdmp_mon,
        cdmp_tue: this.cdmp_tue,
        cdmp_wed: this.cdmp_wed,
        cdmp_thu: this.cdmp_thu,
        cdmp_fri: this.cdmp_fri,
        cdmp_sat: this.cdmp_sat

      };
      __WEBPACK_IMPORTED_MODULE_0__models_truck__["a" /* default */].addTruck(this.$store.state.URLHost, formData, this.header, function (result) {
        if (result.response === true) {
          _this.loadNewTruck();
          _this.alert_msg('success', 'Successful', result.message);
          $('.preloader').fadeOut();
          $('#TruckModal').modal('hide');
        } else {
          _this.loadNewTruck();
          _this.alert_msg('warning', 'An error occurred.', result.message);
          $('.preloader').fadeOut();
          $('#TruckModal').modal('hide');
        }
      }, function (error) {
        _this.loadNewTruck();
        _this.alert_msg('error', 'An error occurred.', error.message);
        $('.preloader').fadeOut();
        $('#TruckModal').modal('hide');
      });
    },
    listPattern: function listPattern() {
      var _this2 = this;

      this.patternModalList = [];
      __WEBPACK_IMPORTED_MODULE_0__models_truck__["a" /* default */].listPattern(this.$store.state.URLHost, this.header, function (result) {
        if (result.response === true) {
          _this2.patternModalList = result.data;
        } else {
          _this2.alert_msg('warning', 'An error occurred.', result.message);
        }
      }, function (error) {
        _this2.alert_msg('error', 'An error occurred.', error.message);
      });
    },
    listTrucktype: function listTrucktype() {
      var _this3 = this;

      this.trucktypeModalList = [];
      __WEBPACK_IMPORTED_MODULE_0__models_truck__["a" /* default */].listTrucktype(this.$store.state.URLHost, this.header, function (result) {
        if (result.response === true) {
          _this3.trucktypeModalList = result.data;
        } else {
          _this3.alert_msg('warning', 'An error occurred.', result.message);
        }
      }, function (error) {
        _this3.alert_msg('error', 'An error occurred.', error.message);
      });
    }
  },
  watch: {
    modalAddTruck: {
      immediate: true,
      deep: true,
      handler: function handler(newValue, oldValue) {
        this.listPattern();
        this.listTrucktype();
        this.spl_name = newValue.spl_name;
        this.spl_id = newValue.spl_id;
        this.spl_plant_code = newValue.spl_plant_code;
        // this.cdmp_sequence = newValue.cdmp_sequence
      }
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    var myModalEl = document.getElementById('TruckModal');
    myModalEl.addEventListener('shown.bs.modal', function (event) {
      _this4.cdp_id = '1';
      _this4.cdpl_truck_no = '';
      _this4.cdpl_truck_type = '';
      _this4.cdpl_shipping_time_h = '00';
      _this4.cdpl_shipping_time_m = '00';
      _this4.cdpl_lead_time_day = '';
      _this4.cdpl_delivery_time_h = '00';
      _this4.cdpl_delivery_time_m = '00';
      _this4.cdpl_delivery_time_end_h = '00';
      _this4.cdpl_delivery_time_end_m = '00';
      _this4.cdmp_mon = false;
      _this4.cdmp_tue = false;
      _this4.cdmp_wed = false;
      _this4.cdmp_thu = false;
      _this4.cdmp_fri = false;
      _this4.cdmp_sat = false;
      $('#formAddTruck').removeClass('was-validated');
    });
    $(document).on('show.bs.modal', '.modal', function () {
      var zIndex = 1040 + 10 * $('.modal:visible').length;
      $(this).css('z-index', zIndex);
      setTimeout(function () {
        $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
      }, 0);
    });
  }
});

/***/ }),

/***/ 1595:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1596);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1046)("e66fe2b6", content, true, {});

/***/ }),

/***/ 1596:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1045)(true);
// imports


// module
exports.push([module.i, ".my-border[data-v-2c3d0c8b]{border-right:1px solid #e9edf2}", "", {"version":3,"sources":["/vercel/path0/ui/src/views/Truckdetail.vue"],"names":[],"mappings":"AACA,4BACE,8BAAgC,CACjC","file":"Truckdetail.vue","sourcesContent":["\n.my-border[data-v-2c3d0c8b] {\n  border-right: 1px solid #e9edf2;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1597:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_truck_edit_modal_vue__ = __webpack_require__(1363);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8cffcb98_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_truck_edit_modal_vue__ = __webpack_require__(1598);
var normalizeComponent = __webpack_require__(509)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_truck_edit_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8cffcb98_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_truck_edit_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1598:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{staticClass:"form-horizontal needs-validation",attrs:{"novalidate":"","id":"formEditTruck"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-xlg-6 col-md-6"},[_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Supplier")]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.spl_name),expression:"spl_name"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.spl_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.spl_name=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.spl_id),expression:"spl_id"}],staticClass:"form-control",attrs:{"type":"hidden"},domProps:{"value":(_vm.spl_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.spl_id=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Pattern")]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdp_name),expression:"cdp_name"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.cdp_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cdp_name=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Truck No.")]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdpl_truck_no),expression:"cdpl_truck_no"}],staticClass:"form-control",attrs:{"type":"number","required":""},domProps:{"value":(_vm.cdpl_truck_no)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cdpl_truck_no=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                Please enter truck No.\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Lead-Time Day (S)")]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdpl_lead_time_day),expression:"cdpl_lead_time_day"}],staticClass:"form-control",attrs:{"type":"number","required":""},domProps:{"value":(_vm.cdpl_lead_time_day)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cdpl_lead_time_day=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                Please enter lead-time day (S).\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Day")]),_vm._v(" "),_c('a-row',[_c('a-col',{attrs:{"span":8}},[_c('a-checkbox',{attrs:{"value":""},model:{value:(_vm.cdmp_mon),callback:function ($$v) {_vm.cdmp_mon=$$v},expression:"cdmp_mon"}},[_vm._v("\n                  Mon\n                ")])],1),_vm._v(" "),_c('a-col',{attrs:{"span":8}},[_c('a-checkbox',{attrs:{"value":""},model:{value:(_vm.cdmp_tue),callback:function ($$v) {_vm.cdmp_tue=$$v},expression:"cdmp_tue"}},[_vm._v("\n                  Tue\n                ")])],1),_vm._v(" "),_c('a-col',{attrs:{"span":8}},[_c('a-checkbox',{attrs:{"value":""},model:{value:(_vm.cdmp_wed),callback:function ($$v) {_vm.cdmp_wed=$$v},expression:"cdmp_wed"}},[_vm._v("\n                  Wed\n                ")])],1),_vm._v(" "),_c('a-col',{attrs:{"span":8}},[_c('a-checkbox',{attrs:{"value":""},model:{value:(_vm.cdmp_thu),callback:function ($$v) {_vm.cdmp_thu=$$v},expression:"cdmp_thu"}},[_vm._v("\n                  Thu\n                ")])],1),_vm._v(" "),_c('a-col',{attrs:{"span":8}},[_c('a-checkbox',{attrs:{"value":""},model:{value:(_vm.cdmp_fri),callback:function ($$v) {_vm.cdmp_fri=$$v},expression:"cdmp_fri"}},[_vm._v("\n                  Fri\n                ")])],1),_vm._v(" "),_c('a-col',{attrs:{"span":8}},[_c('a-checkbox',{attrs:{"value":""},model:{value:(_vm.cdmp_sat),callback:function ($$v) {_vm.cdmp_sat=$$v},expression:"cdmp_sat"}},[_vm._v("\n                  Sat\n                ")])],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-xlg-6 col-md-6"},[_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Plant Code")]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.spl_plant_code),expression:"spl_plant_code"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.spl_plant_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.spl_plant_code=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Truck type")]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdpl_truck_type),expression:"cdpl_truck_type"}],staticClass:"form-control-line form-select form-select-fix",staticStyle:{"width":"100%"},attrs:{"placeholder":"Choose Truck Type..."},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cdpl_truck_type=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"selected":"","value":""}},[_vm._v("Choose truck type")]),_vm._v(" "),_vm._l((_vm.trucktypeModalList),function(tt,i){return _c('option',{key:'tt' + i,domProps:{"value":tt.tt_name}},[_vm._v("\n                  "+_vm._s(tt.tt_name)+"\n                ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Shipping time")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdpl_shipping_time_h),expression:"cdpl_shipping_time_h"}],staticClass:"form-control-line form-select form-select-fix",staticStyle:{"width":"100%"},attrs:{"required":"","placeholder":"Choose Shipping Time..."},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cdpl_shipping_time_h=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"00"}},[_vm._v("00")]),_vm._v(" "),_c('option',{attrs:{"value":"01"}},[_vm._v("01")]),_vm._v(" "),_c('option',{attrs:{"value":"02"}},[_vm._v("02")]),_vm._v(" "),_c('option',{attrs:{"value":"03"}},[_vm._v("03")]),_vm._v(" "),_c('option',{attrs:{"value":"04"}},[_vm._v("04")]),_vm._v(" "),_c('option',{attrs:{"value":"05"}},[_vm._v("05")]),_vm._v(" "),_c('option',{attrs:{"value":"06"}},[_vm._v("06")]),_vm._v(" "),_c('option',{attrs:{"value":"07"}},[_vm._v("07")]),_vm._v(" "),_c('option',{attrs:{"value":"08"}},[_vm._v("08")]),_vm._v(" "),_c('option',{attrs:{"value":"09"}},[_vm._v("09")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("11")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("12")]),_vm._v(" "),_c('option',{attrs:{"value":"13"}},[_vm._v("13")]),_vm._v(" "),_c('option',{attrs:{"value":"14"}},[_vm._v("14")]),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("15")]),_vm._v(" "),_c('option',{attrs:{"value":"16"}},[_vm._v("16")]),_vm._v(" "),_c('option',{attrs:{"value":"17"}},[_vm._v("17")]),_vm._v(" "),_c('option',{attrs:{"value":"18"}},[_vm._v("18")]),_vm._v(" "),_c('option',{attrs:{"value":"19"}},[_vm._v("19")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"21"}},[_vm._v("21")]),_vm._v(" "),_c('option',{attrs:{"value":"22"}},[_vm._v("22")]),_vm._v(" "),_c('option',{attrs:{"value":"23"}},[_vm._v("23")]),_vm._v(" "),_c('option',{attrs:{"value":"24"}},[_vm._v("24")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"26"}},[_vm._v("26")]),_vm._v(" "),_c('option',{attrs:{"value":"27"}},[_vm._v("27")]),_vm._v(" "),_c('option',{attrs:{"value":"28"}},[_vm._v("28")]),_vm._v(" "),_c('option',{attrs:{"value":"29"}},[_vm._v("29")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("30")]),_vm._v(" "),_c('option',{attrs:{"value":"31"}},[_vm._v("31")]),_vm._v(" "),_c('option',{attrs:{"value":"32"}},[_vm._v("32")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdpl_shipping_time_m),expression:"cdpl_shipping_time_m"}],staticClass:"form-control-line form-select form-select-fix",staticStyle:{"width":"100%"},attrs:{"required":"","placeholder":"Choose Shipping Minute..."},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cdpl_shipping_time_m=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"00"}},[_vm._v("00")]),_vm._v(" "),_c('option',{attrs:{"value":"05"}},[_vm._v("05")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("15")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("30")]),_vm._v(" "),_c('option',{attrs:{"value":"35"}},[_vm._v("35")]),_vm._v(" "),_c('option',{attrs:{"value":"40"}},[_vm._v("40")]),_vm._v(" "),_c('option',{attrs:{"value":"45"}},[_vm._v("45")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"55"}},[_vm._v("55")])])])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Delivery start time")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdpl_delivery_time_h),expression:"cdpl_delivery_time_h"}],staticClass:"form-control-line form-select form-select-fix",staticStyle:{"width":"100%"},attrs:{"required":"","placeholder":"Choose Delivery Start Time..."},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cdpl_delivery_time_h=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"00"}},[_vm._v("00")]),_vm._v(" "),_c('option',{attrs:{"value":"01"}},[_vm._v("01")]),_vm._v(" "),_c('option',{attrs:{"value":"02"}},[_vm._v("02")]),_vm._v(" "),_c('option',{attrs:{"value":"03"}},[_vm._v("03")]),_vm._v(" "),_c('option',{attrs:{"value":"04"}},[_vm._v("04")]),_vm._v(" "),_c('option',{attrs:{"value":"05"}},[_vm._v("05")]),_vm._v(" "),_c('option',{attrs:{"value":"06"}},[_vm._v("06")]),_vm._v(" "),_c('option',{attrs:{"value":"07"}},[_vm._v("07")]),_vm._v(" "),_c('option',{attrs:{"value":"08"}},[_vm._v("08")]),_vm._v(" "),_c('option',{attrs:{"value":"09"}},[_vm._v("09")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("11")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("12")]),_vm._v(" "),_c('option',{attrs:{"value":"13"}},[_vm._v("13")]),_vm._v(" "),_c('option',{attrs:{"value":"14"}},[_vm._v("14")]),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("15")]),_vm._v(" "),_c('option',{attrs:{"value":"16"}},[_vm._v("16")]),_vm._v(" "),_c('option',{attrs:{"value":"17"}},[_vm._v("17")]),_vm._v(" "),_c('option',{attrs:{"value":"18"}},[_vm._v("18")]),_vm._v(" "),_c('option',{attrs:{"value":"19"}},[_vm._v("19")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"21"}},[_vm._v("21")]),_vm._v(" "),_c('option',{attrs:{"value":"22"}},[_vm._v("22")]),_vm._v(" "),_c('option',{attrs:{"value":"23"}},[_vm._v("23")]),_vm._v(" "),_c('option',{attrs:{"value":"24"}},[_vm._v("24")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"26"}},[_vm._v("26")]),_vm._v(" "),_c('option',{attrs:{"value":"27"}},[_vm._v("27")]),_vm._v(" "),_c('option',{attrs:{"value":"28"}},[_vm._v("28")]),_vm._v(" "),_c('option',{attrs:{"value":"29"}},[_vm._v("29")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("30")]),_vm._v(" "),_c('option',{attrs:{"value":"31"}},[_vm._v("31")]),_vm._v(" "),_c('option',{attrs:{"value":"32"}},[_vm._v("32")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdpl_delivery_time_m),expression:"cdpl_delivery_time_m"}],staticClass:"form-control-line form-select form-select-fix",staticStyle:{"width":"100%"},attrs:{"required":"","placeholder":"Choose Delivery Start Minute..."},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cdpl_delivery_time_m=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"00"}},[_vm._v("00")]),_vm._v(" "),_c('option',{attrs:{"value":"05"}},[_vm._v("05")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("15")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("30")]),_vm._v(" "),_c('option',{attrs:{"value":"35"}},[_vm._v("35")]),_vm._v(" "),_c('option',{attrs:{"value":"40"}},[_vm._v("40")]),_vm._v(" "),_c('option',{attrs:{"value":"45"}},[_vm._v("45")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"55"}},[_vm._v("55")])])])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Delivery finish time")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdpl_delivery_time_end_h),expression:"cdpl_delivery_time_end_h"}],staticClass:"form-control-line form-select form-select-fix",staticStyle:{"width":"100%"},attrs:{"required":"","placeholder":"Choose Delivery Finish Time..."},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cdpl_delivery_time_end_h=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"00"}},[_vm._v("00")]),_vm._v(" "),_c('option',{attrs:{"value":"01"}},[_vm._v("01")]),_vm._v(" "),_c('option',{attrs:{"value":"02"}},[_vm._v("02")]),_vm._v(" "),_c('option',{attrs:{"value":"03"}},[_vm._v("03")]),_vm._v(" "),_c('option',{attrs:{"value":"04"}},[_vm._v("04")]),_vm._v(" "),_c('option',{attrs:{"value":"05"}},[_vm._v("05")]),_vm._v(" "),_c('option',{attrs:{"value":"06"}},[_vm._v("06")]),_vm._v(" "),_c('option',{attrs:{"value":"07"}},[_vm._v("07")]),_vm._v(" "),_c('option',{attrs:{"value":"08"}},[_vm._v("08")]),_vm._v(" "),_c('option',{attrs:{"value":"09"}},[_vm._v("09")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("11")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("12")]),_vm._v(" "),_c('option',{attrs:{"value":"13"}},[_vm._v("13")]),_vm._v(" "),_c('option',{attrs:{"value":"14"}},[_vm._v("14")]),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("15")]),_vm._v(" "),_c('option',{attrs:{"value":"16"}},[_vm._v("16")]),_vm._v(" "),_c('option',{attrs:{"value":"17"}},[_vm._v("17")]),_vm._v(" "),_c('option',{attrs:{"value":"18"}},[_vm._v("18")]),_vm._v(" "),_c('option',{attrs:{"value":"19"}},[_vm._v("19")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"21"}},[_vm._v("21")]),_vm._v(" "),_c('option',{attrs:{"value":"22"}},[_vm._v("22")]),_vm._v(" "),_c('option',{attrs:{"value":"23"}},[_vm._v("23")]),_vm._v(" "),_c('option',{attrs:{"value":"24"}},[_vm._v("24")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"26"}},[_vm._v("26")]),_vm._v(" "),_c('option',{attrs:{"value":"27"}},[_vm._v("27")]),_vm._v(" "),_c('option',{attrs:{"value":"28"}},[_vm._v("28")]),_vm._v(" "),_c('option',{attrs:{"value":"29"}},[_vm._v("29")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("30")]),_vm._v(" "),_c('option',{attrs:{"value":"31"}},[_vm._v("31")]),_vm._v(" "),_c('option',{attrs:{"value":"32"}},[_vm._v("32")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdpl_delivery_time_end_m),expression:"cdpl_delivery_time_end_m"}],staticClass:"form-control-line form-select form-select-fix",staticStyle:{"width":"100%"},attrs:{"required":"","placeholder":"Choose Delivery Finish Minute..."},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cdpl_delivery_time_end_m=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"00"}},[_vm._v("00")]),_vm._v(" "),_c('option',{attrs:{"value":"05"}},[_vm._v("05")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("15")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("30")]),_vm._v(" "),_c('option',{attrs:{"value":"35"}},[_vm._v("35")]),_vm._v(" "),_c('option',{attrs:{"value":"40"}},[_vm._v("40")]),_vm._v(" "),_c('option',{attrs:{"value":"45"}},[_vm._v("45")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"55"}},[_vm._v("55")])])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._m(1),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fix",attrs:{"type":"button","id":"submitbtn"},on:{"click":_vm.checkForm}},[_c('i',{staticClass:"fas fa-save"}),_vm._v(" Save")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"TruckModalLabel"}},[_vm._v("Edit")]),_vm._v(" "),_c('button',{staticClass:"btn-close",attrs:{"type":"button","data-bs-dismiss":"modal","aria-label":"Close"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-secondary btn-fix",attrs:{"type":"button","data-bs-dismiss":"modal","id":"supplierModalclose"}},[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Close")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1599:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_truck_add_modal_vue__ = __webpack_require__(1364);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b01c9d5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_truck_add_modal_vue__ = __webpack_require__(1600);
var normalizeComponent = __webpack_require__(509)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_truck_add_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b01c9d5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_truck_add_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1600:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{staticClass:"form-horizontal needs-validation",attrs:{"novalidate":"","id":"formAddTruck"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-xlg-6 col-md-6"},[_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Supplier")]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.spl_name),expression:"spl_name"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.spl_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.spl_name=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.spl_id),expression:"spl_id"}],staticClass:"form-control",attrs:{"type":"hidden"},domProps:{"value":(_vm.spl_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.spl_id=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Pattern")]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdp_id),expression:"cdp_id"}],staticClass:"form-control-line form-select form-select-fix",staticStyle:{"width":"100%"},attrs:{"required":"","placeholder":"Choose pattern..."},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cdp_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"selected":"","value":""}},[_vm._v("Choose pattern")]),_vm._v(" "),_vm._l((_vm.patternModalList),function(cdp,i){return _c('option',{key:'cdp' + i,domProps:{"value":cdp.cdp_id}},[_vm._v("\n                  "+_vm._s(cdp.cdp_name)+"\n                ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Truck No.")]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdpl_truck_no),expression:"cdpl_truck_no"}],staticClass:"form-control",attrs:{"type":"number","required":""},domProps:{"value":(_vm.cdpl_truck_no)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cdpl_truck_no=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                Please enter truck No.\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Lead-Time Day (S)")]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdpl_lead_time_day),expression:"cdpl_lead_time_day"}],staticClass:"form-control",attrs:{"type":"number","required":""},domProps:{"value":(_vm.cdpl_lead_time_day)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cdpl_lead_time_day=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n                Please enter lead-time day (S).\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Day")]),_vm._v(" "),_c('a-row',[_c('a-col',{attrs:{"span":8}},[_c('a-checkbox',{attrs:{"value":"1"},model:{value:(_vm.cdmp_mon),callback:function ($$v) {_vm.cdmp_mon=$$v},expression:"cdmp_mon"}},[_vm._v("\n                  Mon\n                ")])],1),_vm._v(" "),_c('a-col',{attrs:{"span":8}},[_c('a-checkbox',{attrs:{"value":"1"},model:{value:(_vm.cdmp_tue),callback:function ($$v) {_vm.cdmp_tue=$$v},expression:"cdmp_tue"}},[_vm._v("\n                  Tue\n                ")])],1),_vm._v(" "),_c('a-col',{attrs:{"span":8}},[_c('a-checkbox',{attrs:{"value":"1"},model:{value:(_vm.cdmp_wed),callback:function ($$v) {_vm.cdmp_wed=$$v},expression:"cdmp_wed"}},[_vm._v("\n                  Wed\n                ")])],1),_vm._v(" "),_c('a-col',{attrs:{"span":8}},[_c('a-checkbox',{attrs:{"value":"1"},model:{value:(_vm.cdmp_thu),callback:function ($$v) {_vm.cdmp_thu=$$v},expression:"cdmp_thu"}},[_vm._v("\n                  Thu\n                ")])],1),_vm._v(" "),_c('a-col',{attrs:{"span":8}},[_c('a-checkbox',{attrs:{"value":"1"},model:{value:(_vm.cdmp_fri),callback:function ($$v) {_vm.cdmp_fri=$$v},expression:"cdmp_fri"}},[_vm._v("\n                  Fri\n                ")])],1),_vm._v(" "),_c('a-col',{attrs:{"span":8}},[_c('a-checkbox',{attrs:{"value":"1"},model:{value:(_vm.cdmp_sat),callback:function ($$v) {_vm.cdmp_sat=$$v},expression:"cdmp_sat"}},[_vm._v("\n                  Sat\n                ")])],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-xlg-6 col-md-6"},[_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Plant Code")]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.spl_plant_code),expression:"spl_plant_code"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.spl_plant_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.spl_plant_code=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Truck type")]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdpl_truck_type),expression:"cdpl_truck_type"}],staticClass:"form-control-line form-select form-select-fix",staticStyle:{"width":"100%"},attrs:{"placeholder":"Choose Truck Type..."},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cdpl_truck_type=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"selected":"","value":""}},[_vm._v("Choose truck type")]),_vm._v(" "),_vm._l((_vm.trucktypeModalList),function(tt,i){return _c('option',{key:'tt' + i,domProps:{"value":tt.tt_name}},[_vm._v("\n                  "+_vm._s(tt.tt_name)+"\n                ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Shipping time")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdpl_shipping_time_h),expression:"cdpl_shipping_time_h"}],staticClass:"form-control-line form-select form-select-fix",staticStyle:{"width":"100%"},attrs:{"required":"","placeholder":"Choose Shipping Time..."},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cdpl_shipping_time_h=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"00"}},[_vm._v("00")]),_vm._v(" "),_c('option',{attrs:{"value":"01"}},[_vm._v("01")]),_vm._v(" "),_c('option',{attrs:{"value":"02"}},[_vm._v("02")]),_vm._v(" "),_c('option',{attrs:{"value":"03"}},[_vm._v("03")]),_vm._v(" "),_c('option',{attrs:{"value":"04"}},[_vm._v("04")]),_vm._v(" "),_c('option',{attrs:{"value":"05"}},[_vm._v("05")]),_vm._v(" "),_c('option',{attrs:{"value":"06"}},[_vm._v("06")]),_vm._v(" "),_c('option',{attrs:{"value":"07"}},[_vm._v("07")]),_vm._v(" "),_c('option',{attrs:{"value":"08"}},[_vm._v("08")]),_vm._v(" "),_c('option',{attrs:{"value":"09"}},[_vm._v("09")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("11")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("12")]),_vm._v(" "),_c('option',{attrs:{"value":"13"}},[_vm._v("13")]),_vm._v(" "),_c('option',{attrs:{"value":"14"}},[_vm._v("14")]),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("15")]),_vm._v(" "),_c('option',{attrs:{"value":"16"}},[_vm._v("16")]),_vm._v(" "),_c('option',{attrs:{"value":"17"}},[_vm._v("17")]),_vm._v(" "),_c('option',{attrs:{"value":"18"}},[_vm._v("18")]),_vm._v(" "),_c('option',{attrs:{"value":"19"}},[_vm._v("19")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"21"}},[_vm._v("21")]),_vm._v(" "),_c('option',{attrs:{"value":"22"}},[_vm._v("22")]),_vm._v(" "),_c('option',{attrs:{"value":"23"}},[_vm._v("23")]),_vm._v(" "),_c('option',{attrs:{"value":"24"}},[_vm._v("24")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"26"}},[_vm._v("26")]),_vm._v(" "),_c('option',{attrs:{"value":"27"}},[_vm._v("27")]),_vm._v(" "),_c('option',{attrs:{"value":"28"}},[_vm._v("28")]),_vm._v(" "),_c('option',{attrs:{"value":"29"}},[_vm._v("29")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("30")]),_vm._v(" "),_c('option',{attrs:{"value":"31"}},[_vm._v("31")]),_vm._v(" "),_c('option',{attrs:{"value":"32"}},[_vm._v("32")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdpl_shipping_time_m),expression:"cdpl_shipping_time_m"}],staticClass:"form-control-line form-select form-select-fix",staticStyle:{"width":"100%"},attrs:{"required":"","placeholder":"Choose Shipping Minute..."},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cdpl_shipping_time_m=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"00"}},[_vm._v("00")]),_vm._v(" "),_c('option',{attrs:{"value":"05"}},[_vm._v("05")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("15")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("30")]),_vm._v(" "),_c('option',{attrs:{"value":"35"}},[_vm._v("35")]),_vm._v(" "),_c('option',{attrs:{"value":"40"}},[_vm._v("40")]),_vm._v(" "),_c('option',{attrs:{"value":"45"}},[_vm._v("45")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"55"}},[_vm._v("55")])])])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Delivery start time")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdpl_delivery_time_h),expression:"cdpl_delivery_time_h"}],staticClass:"form-control-line form-select form-select-fix",staticStyle:{"width":"100%"},attrs:{"required":"","placeholder":"Choose Delivery Start Time..."},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cdpl_delivery_time_h=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"00"}},[_vm._v("00")]),_vm._v(" "),_c('option',{attrs:{"value":"01"}},[_vm._v("01")]),_vm._v(" "),_c('option',{attrs:{"value":"02"}},[_vm._v("02")]),_vm._v(" "),_c('option',{attrs:{"value":"03"}},[_vm._v("03")]),_vm._v(" "),_c('option',{attrs:{"value":"04"}},[_vm._v("04")]),_vm._v(" "),_c('option',{attrs:{"value":"05"}},[_vm._v("05")]),_vm._v(" "),_c('option',{attrs:{"value":"06"}},[_vm._v("06")]),_vm._v(" "),_c('option',{attrs:{"value":"07"}},[_vm._v("07")]),_vm._v(" "),_c('option',{attrs:{"value":"08"}},[_vm._v("08")]),_vm._v(" "),_c('option',{attrs:{"value":"09"}},[_vm._v("09")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("11")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("12")]),_vm._v(" "),_c('option',{attrs:{"value":"13"}},[_vm._v("13")]),_vm._v(" "),_c('option',{attrs:{"value":"14"}},[_vm._v("14")]),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("15")]),_vm._v(" "),_c('option',{attrs:{"value":"16"}},[_vm._v("16")]),_vm._v(" "),_c('option',{attrs:{"value":"17"}},[_vm._v("17")]),_vm._v(" "),_c('option',{attrs:{"value":"18"}},[_vm._v("18")]),_vm._v(" "),_c('option',{attrs:{"value":"19"}},[_vm._v("19")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"21"}},[_vm._v("21")]),_vm._v(" "),_c('option',{attrs:{"value":"22"}},[_vm._v("22")]),_vm._v(" "),_c('option',{attrs:{"value":"23"}},[_vm._v("23")]),_vm._v(" "),_c('option',{attrs:{"value":"24"}},[_vm._v("24")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"26"}},[_vm._v("26")]),_vm._v(" "),_c('option',{attrs:{"value":"27"}},[_vm._v("27")]),_vm._v(" "),_c('option',{attrs:{"value":"28"}},[_vm._v("28")]),_vm._v(" "),_c('option',{attrs:{"value":"29"}},[_vm._v("29")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("30")]),_vm._v(" "),_c('option',{attrs:{"value":"31"}},[_vm._v("31")]),_vm._v(" "),_c('option',{attrs:{"value":"32"}},[_vm._v("32")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdpl_delivery_time_m),expression:"cdpl_delivery_time_m"}],staticClass:"form-control-line form-select form-select-fix",staticStyle:{"width":"100%"},attrs:{"required":"","placeholder":"Choose Delivery Start Minute..."},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cdpl_delivery_time_m=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"00"}},[_vm._v("00")]),_vm._v(" "),_c('option',{attrs:{"value":"05"}},[_vm._v("05")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("15")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("30")]),_vm._v(" "),_c('option',{attrs:{"value":"35"}},[_vm._v("35")]),_vm._v(" "),_c('option',{attrs:{"value":"40"}},[_vm._v("40")]),_vm._v(" "),_c('option',{attrs:{"value":"45"}},[_vm._v("45")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"55"}},[_vm._v("55")])])])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Delivery finish time")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdpl_delivery_time_end_h),expression:"cdpl_delivery_time_end_h"}],staticClass:"form-control-line form-select form-select-fix",staticStyle:{"width":"100%"},attrs:{"required":"","placeholder":"Choose Delivery Finish Time..."},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cdpl_delivery_time_end_h=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"00"}},[_vm._v("00")]),_vm._v(" "),_c('option',{attrs:{"value":"01"}},[_vm._v("01")]),_vm._v(" "),_c('option',{attrs:{"value":"02"}},[_vm._v("02")]),_vm._v(" "),_c('option',{attrs:{"value":"03"}},[_vm._v("03")]),_vm._v(" "),_c('option',{attrs:{"value":"04"}},[_vm._v("04")]),_vm._v(" "),_c('option',{attrs:{"value":"05"}},[_vm._v("05")]),_vm._v(" "),_c('option',{attrs:{"value":"06"}},[_vm._v("06")]),_vm._v(" "),_c('option',{attrs:{"value":"07"}},[_vm._v("07")]),_vm._v(" "),_c('option',{attrs:{"value":"08"}},[_vm._v("08")]),_vm._v(" "),_c('option',{attrs:{"value":"09"}},[_vm._v("09")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("11")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("12")]),_vm._v(" "),_c('option',{attrs:{"value":"13"}},[_vm._v("13")]),_vm._v(" "),_c('option',{attrs:{"value":"14"}},[_vm._v("14")]),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("15")]),_vm._v(" "),_c('option',{attrs:{"value":"16"}},[_vm._v("16")]),_vm._v(" "),_c('option',{attrs:{"value":"17"}},[_vm._v("17")]),_vm._v(" "),_c('option',{attrs:{"value":"18"}},[_vm._v("18")]),_vm._v(" "),_c('option',{attrs:{"value":"19"}},[_vm._v("19")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"21"}},[_vm._v("21")]),_vm._v(" "),_c('option',{attrs:{"value":"22"}},[_vm._v("22")]),_vm._v(" "),_c('option',{attrs:{"value":"23"}},[_vm._v("23")]),_vm._v(" "),_c('option',{attrs:{"value":"24"}},[_vm._v("24")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"26"}},[_vm._v("26")]),_vm._v(" "),_c('option',{attrs:{"value":"27"}},[_vm._v("27")]),_vm._v(" "),_c('option',{attrs:{"value":"28"}},[_vm._v("28")]),_vm._v(" "),_c('option',{attrs:{"value":"29"}},[_vm._v("29")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("30")]),_vm._v(" "),_c('option',{attrs:{"value":"31"}},[_vm._v("31")]),_vm._v(" "),_c('option',{attrs:{"value":"32"}},[_vm._v("32")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdpl_delivery_time_end_m),expression:"cdpl_delivery_time_end_m"}],staticClass:"form-control-line form-select form-select-fix",staticStyle:{"width":"100%"},attrs:{"required":"","placeholder":"Choose Delivery Finish Minute..."},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cdpl_delivery_time_end_m=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"00"}},[_vm._v("00")]),_vm._v(" "),_c('option',{attrs:{"value":"05"}},[_vm._v("05")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("15")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("30")]),_vm._v(" "),_c('option',{attrs:{"value":"35"}},[_vm._v("35")]),_vm._v(" "),_c('option',{attrs:{"value":"40"}},[_vm._v("40")]),_vm._v(" "),_c('option',{attrs:{"value":"45"}},[_vm._v("45")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"55"}},[_vm._v("55")])])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._m(1),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fix",attrs:{"type":"button","id":"submitbtn"},on:{"click":_vm.checkForm}},[_c('i',{staticClass:"fas fa-save"}),_vm._v(" Save")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"TruckModalLabel"}},[_vm._v("Add")]),_vm._v(" "),_c('button',{staticClass:"btn-close",attrs:{"type":"button","data-bs-dismiss":"modal","aria-label":"Close"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-secondary btn-fix",attrs:{"type":"button","data-bs-dismiss":"modal","id":"supplierModalclose"}},[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Close")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1601:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"d-lg-flex"},[_c('div',{staticClass:"col-sm-7"},[_c('h3',{staticClass:"card-title"},[_c('span',{staticClass:"lstick d-inline-block align-middle"}),_vm._v(_vm._s(_vm.$route.meta.title_sub !== '' ? _vm.$route.meta.title_sub : _vm.$route.meta.title)+"\n        ")]),_vm._v(" "),_c('h6',{staticClass:"card-subtitle"})]),_vm._v(" "),_c('div',{staticClass:"col-sm-5 text-end"},[_c('button',{staticClass:"btn btn-secondary btn-sm btn-sm-fix",on:{"click":_vm.backTopage}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" Back")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-sm btn-sm-fix",on:{"click":_vm.addTrucklist}},[_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" Add")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-sm btn-sm-fix",on:{"click":_vm.goTruckPattern}},[_c('i',{staticClass:"fa fa-link"}),_vm._v(" Truck Calendar")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-2"},[_c('div',{staticClass:"col-sm-12"},[_c('h4',[_vm._v("Supplier: "+_vm._s(this.spl_code + ' | ' + this.spl_name + ' | ' + this.spl_plant_code))])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"table-responsive tableFixHead"},[_c('table',{staticClass:"table customize-table mb-0 v-middle"},[_vm._m(0),_vm._v(" "),_c('tbody',[_c('tr',[(_vm.isLoad == true)?_c('td',{staticClass:"text-center",attrs:{"colspan":"14"}},[_c('i',{staticClass:"fas fa-sync-alt fa-spin fa-2x fa-fw"})]):_vm._e()]),_vm._v(" "),_vm._l((_vm.result_data),function(rs,i){return _c('tr',{key:'rs' + i},[(rs.check_row == 1)?_c('td',{staticClass:"align-top text-center my-border",attrs:{"rowspan":rs.count_list}},[_vm._v(_vm._s(rs.cdp_name))]):_vm._e(),_vm._v(" "),(rs.check_row == 1)?_c('td',{staticClass:"align-top text-center my-border",attrs:{"rowspan":rs.count_list}},[_vm._v(_vm._s(rs.cdmp_mon === 0 ? '-' : 1))]):_vm._e(),_vm._v(" "),(rs.check_row == 1)?_c('td',{staticClass:"align-top text-center my-border",attrs:{"rowspan":rs.count_list}},[_vm._v(_vm._s(rs.cdmp_tue === 0 ? '-' : 1))]):_vm._e(),_vm._v(" "),(rs.check_row == 1)?_c('td',{staticClass:"align-top text-center my-border",attrs:{"rowspan":rs.count_list}},[_vm._v(_vm._s(rs.cdmp_wed === 0 ? '-' : 1))]):_vm._e(),_vm._v(" "),(rs.check_row == 1)?_c('td',{staticClass:"align-top text-center my-border",attrs:{"rowspan":rs.count_list}},[_vm._v(_vm._s(rs.cdmp_thu === 0 ? '-' : 1))]):_vm._e(),_vm._v(" "),(rs.check_row == 1)?_c('td',{staticClass:"align-top text-center my-border",attrs:{"rowspan":rs.count_list}},[_vm._v(_vm._s(rs.cdmp_fri === 0 ? '-' : 1))]):_vm._e(),_vm._v(" "),(rs.check_row == 1)?_c('td',{staticClass:"align-top text-center my-border",attrs:{"rowspan":rs.count_list}},[_vm._v(_vm._s(rs.cdmp_sat === 0 ? '-' : 1))]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"align-top my-border"},[_vm._v(_vm._s(rs.cdpl_truck_no))]),_vm._v(" "),_c('td',{staticClass:"align-top my-border"},[_vm._v(_vm._s(rs.cdpl_truck_type))]),_vm._v(" "),_c('td',{staticClass:"align-top text-center my-border"},[_vm._v(_vm._s(rs.cdpl_shipping_time))]),_vm._v(" "),_c('td',{staticClass:"align-top text-center my-border"},[_vm._v(_vm._s(rs.cdpl_lead_time_day))]),_vm._v(" "),_c('td',{staticClass:"align-top text-center my-border"},[_vm._v(_vm._s(rs.cdpl_delivery_time))]),_vm._v(" "),_c('td',{staticClass:"align-top text-center my-border"},[_vm._v(_vm._s(rs.cdpl_delivery_time_end))]),_vm._v(" "),_c('td',{staticClass:"text-center align-top my-border"},[_c('div',{staticClass:"dropdown dropstart my-border"},[_c('a',{staticClass:"link",attrs:{"href":"#","id":"dropdownMenuButton","data-bs-toggle":"dropdown","aria-expanded":"false"}},[_c('svg',{staticClass:"feather feather-more-horizontal feather-sm",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"1"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"19","cy":"12","r":"1"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"5","cy":"12","r":"1"}})])]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu pt-0 pb-0",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('li',[_c('button',{staticClass:"dropdown-item",on:{"click":function($event){return _vm.editTrucklist(rs)}}},[_vm._v("Edit")])]),_vm._v(" "),(rs.check_cycle === 0)?_c('li',[_c('button',{staticClass:"dropdown-item",on:{"click":function($event){return _vm.deleteTrucklist(rs)}}},[_vm._v("Delete")])]):_vm._e(),_vm._v(" "),(rs.check_cycle > 0)?_c('li',[_c('button',{staticClass:"dropdown-item"},[_vm._v("Disable Delete")])]):_vm._e()])])])])}),_vm._v(" "),(_vm.result_data.length < 1 && _vm.isLoad == false)?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"14"}},[_vm._v("No Data")])]):_vm._e()],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"TruckModal","data-backdrop":"static","data-keyboard":"false","tabindex":"-1","aria-labelledby":"TruckModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-fullscreen-md-down modal-lg modal-dialog-centered modal-dialog-scrollable"},[(_vm.modal_type === 1)?_c('truckListEditModal',{attrs:{"modalEditTruck":_vm.modal_data,"loadNewTruck":function () {
            _vm.search = _vm.search
            _vm.activePage(1)
          }}}):_vm._e(),_vm._v(" "),(_vm.modal_type === 0)?_c('trucklistAddModal',{attrs:{"modalAddTruck":_vm.modal_data,"loadNewTruck":function () {
            _vm.search = _vm.search
            _vm.activePage(1)
          }}}):_vm._e()],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"table-light"},[_c('tr',[_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("Pattern")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("Mon")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("Tue")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("Wed")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("Thu")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("Fri")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("Sat")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("Truck No.")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("Truck Type")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("Shipping Time")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("Lead-Time Day (S)")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("Delivery start time")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("Delivery finish time")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("Actions")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/9.c4aa7c973dfbd15d273c.js